import md5 from 'md5'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Checkbox, Image, Input, Label, Message, Segment } from 'semantic-ui-react'
import { LoginAsync, ObtenerVersionAsync } from '../Models/Inicio'
import { LoginInicio, ShowBusy } from '../Reducers/InicioReducer'
import { useForm } from '../Servicios/useForm.js'
import Swal from 'sweetalert2'
import { Base64Encode, Base64Decode, EVAL, ToJson } from '../Servicios/Tools'

export const Inicio = () => {
    //#region Hooks
    const dispatch = useDispatch();
    const txtUsuario = useRef();
    const { inputValues, setInputValues, OnChange } = useForm({
        Usuario: '',
        Contrasena: '',
        Recordar: false,
    });
    //#endregion

    //#region internalState, setInternalState
    const [internalState, setInternalState] = useState({
        Load: false,
        Version: "0.0"
    })
    //#endregion

    //#region message, setMessage
    const [message, setMessage] = useState({
        header: "Requerido:",
        list: []
    })
    //#endregion

    //#region useEffect: []
    useEffect(() => { Load(); }, [])
    //#endregion

    //#region Metodos
    const Load = async () => {
        const _ls = localStorage.getItem("bitso-reader-login")
        if (_ls) { setInputValues(EVAL(Base64Decode(_ls))) }
        txtUsuario.current.focus();
        // let sr = await ObtenerVersionAsync();
        // setInternalState((state) => ({ ...state, Load: true, Version: sr.Version }));


    }
    const Validar = () => {
        let _valido = true;
        let _list = [];
        if (!inputValues.Usuario) {
            _list = ["Debe Indicar el Key..."];
            _valido = false;
        }
        if (!inputValues.Contrasena) {
            _list = [..._list, "Debe Indicar Secret..."];
            _valido = false;
        }
        setMessage((state) => ({ ...state, list: _list }));
        return _valido;
    }
    const OnClickLogin = async () => {
        if (Validar()) {
            dispatch(ShowBusy());
            const _req = { key: inputValues.Usuario, secret: inputValues.Contrasena }
            const _result = await LoginAsync(_req);
            console.log(_result)
            if (_result.success) {
                localStorage.setItem("bitso-reader-troken", _result.token)
                let _ls = "";
                if (inputValues.Recordar) { _ls = Base64Encode(ToJson(inputValues)) }
                localStorage.setItem("bitso-reader-login", _ls);
                dispatch(ShowBusy(false));
                dispatch(LoginInicio(true))
            } else {
                dispatch(ShowBusy(false));
                await Swal.fire({
                    title: 'Ingresar al Sistema',
                    text: 'Key y/o Secret Incorrecta, ¡Favor de Verificar!',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                })
            }
        }
    }
    //#endregion

    return (
        <div className="login-background animate__animated animate__fadeIn">
            <div className="login-content">
                <Segment basic>
                    <Label as='a' color='black' ribbon>Ingresar al Sistema</Label>
                    <Input ref={txtUsuario}
                        name="Usuario"
                        icon='user'
                        error={!inputValues.Usuario}
                        iconPosition='left'
                        placeholder='Key'
                        style={{ width: "100%", marginBottom: "15px", marginTop: "15px" }}
                        onChange={OnChange}
                        value={inputValues.Usuario}
                    />
                    <br />
                    <Input
                        name='Contrasena'
                        type='password'
                        icon='lock'
                        error={!inputValues.Contrasena}
                        iconPosition='left'
                        placeholder='Secret'
                        style={{ width: "100%", marginBottom: "15px" }}
                        onChange={OnChange}
                        value={inputValues.Contrasena}
                    />
                    <Checkbox
                        name="Recordar"
                        label='Recordar'
                        style={{ width: "100%", marginBottom: "15px" }}
                        onChange={(a, b) => { OnChange({ target: { name: "Recordar", value: !inputValues.Recordar } }) }}
                        checked={inputValues.Recordar}
                    />
                    {message.list.length > 0 && (<Message error header={message.header} list={message.list} className="mensaje-error-login" />)}
                    <Button content='Entrar' secondary style={{ width: "100%", marginBottom: "15px" }} onClick={OnClickLogin} />
                    <div className="login-version">Versión: {internalState.Version}</div>
                </Segment>
            </div>
        </div>
    )
}
